import FileDataService from "@/services/bytepro/filedata.service";

export const fileDataApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    updateFileData({ commit }, { fileData, fileDataId }) {
      return FileDataService.updateFileData(fileData, fileDataId).then(
        (resp) => {
          commit("dummy", "updateFileData - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "updateFileData - error");
          return Promise.reject(error.response);
        }
      );
    },

    getFileDataDetail({ commit }, { loanNumber, option }) {
      if (option === undefined || option === null) {
        option = "BasicSet";
      }
      return FileDataService.getFileDataDetail(loanNumber, option).then(
        (resp) => {
          commit("dummy", "getFileDataDetail - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getFileDataDetail - error");
          return Promise.reject(error.response);
        }
      );
    },

    getPipeline() {
      return FileDataService.getPipeline().then(
        (resp) => {
          return Promise.resolve(resp);
        },
        (error) => {
          return Promise.reject(error.response);
        }
      );
    },

    getDashboardLoanStatus({ commit }) {
      return FileDataService.getDashboardLoanStatus().then(
        (resp) => {
          commit("dummy", "FileDataService.getDashboardLoanStatus - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "FileDataService.getDashboardLoanStatus - error");
          return Promise.reject(error.response);
        }
      );
    },

    getConditionPipeline({ commit }, pipelineFilter) {
      return FileDataService.getConditionPipeline(pipelineFilter).then(
        (resp) => {
          commit("dummy", "FileDataService.getConditionPipeline - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "FileDataService.getConditionPipeline - error");
          return Promise.reject(error.response);
        }
      );
    },

    getLoanNumbers() {
      return FileDataService.getLoanNumbers().then(
        (resp) => {
          return Promise.resolve(resp);
        },
        (error) => {
          return Promise.reject(error.response);
        }
      );
    },

    getLoanStageStatus({ commit }, loanNumber) {
      return FileDataService.getLoanStageStatus(loanNumber).then(
        (resp) => {
          commit("dummy", "getLoanStageStatus - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getLoanStageStatus - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
